import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './plp-filters.module.scss';
import queryString from 'query-string';
import { Alert, Checkbox, Icon } from '@pella/sash-framework';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { isValidArray } from '../../../components/utilities/validations';
import './index.css';

const Filter = (props) => {
	const CSdata = useStaticQuery(query);

	// Transaction Types/Get It Fast
	const [transactionFilters, setTransactionFilters] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'transaction-type'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'transaction-type') + 1
		)[0],
	});
	const dynamicTransactionFilters = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'transaction-type'),
		props.filters?.findIndex((filter) => filter.backend_name === 'transaction-type') + 1
	)[0];
	useEffect(() => {
		if (transactionFilters?.static && transactionFilters?.dynamic !== dynamicTransactionFilters)
			setTransactionFilters({
				...transactionFilters,
				dynamic: dynamicTransactionFilters,
			});
	}, [dynamicTransactionFilters, transactionFilters]);

	// Departments
	const [departmentFilters, setDepartmentFilters] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'Products'),
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'Products') + 1
		)[0],
	});

	// Filters
	let allOtherFilters = [];

	// Material Type
	const [materialTypeFilter, setMaterialTypeFilter] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'material-type'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'material-type') + 1
		)[0],
	});
	const dynamicMaterialTypeFilter = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'material-type'),
		props.filters?.findIndex((filter) => filter.backend_name === 'material-type') + 1
	)[0];
	useEffect(() => {
		if ((materialTypeFilter?.static || (!materialTypeFilter?.static && dynamicMaterialTypeFilter)) && materialTypeFilter?.dynamic !== dynamicMaterialTypeFilter)
			setMaterialTypeFilter({
				...materialTypeFilter,
				dynamic: dynamicMaterialTypeFilter,
			});
	}, [dynamicMaterialTypeFilter, materialTypeFilter]);

	// Product Line
	const [productLineFilter, setProductLineFilter] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'product-line'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'product-line') + 1
		)[0],
	});
	const dynamicProductLineFilter = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'product-line'),
		props.filters?.findIndex((filter) => filter.backend_name === 'product-line') + 1
	)[0];
	useEffect(() => {
		if ((productLineFilter?.static || (!productLineFilter?.static && dynamicProductLineFilter)) && productLineFilter?.dynamic !== dynamicProductLineFilter)
			setProductLineFilter({
				...productLineFilter,
				dynamic: dynamicProductLineFilter,
			});
	}, [dynamicProductLineFilter, productLineFilter]);

	// Product Type
	const [productTypeFilter, setProductTypeFilter] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'product-type'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'product-type') + 1
		)[0],
	});
	const dynamicProductTypeFilter = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'product-type'),
		props.filters?.findIndex((filter) => filter.backend_name === 'product-type') + 1
	)[0];
	useEffect(() => {
		if ((productTypeFilter?.static || (!productTypeFilter?.static && dynamicProductTypeFilter)) && productTypeFilter?.dynamic !== dynamicProductTypeFilter)
			setProductTypeFilter({
				...productTypeFilter,
				dynamic: dynamicProductTypeFilter,
			});
	}, [dynamicProductTypeFilter, productTypeFilter]);

	// Parts Category
	const [partsCategoryFilter, setPartsCategoryFilter] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'Parts Category'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'Parts Category') + 1
		)[0],
	});
	const dynamicPartsCategoryFilter = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'Parts Category'),
		props.filters?.findIndex((filter) => filter.backend_name === 'Parts Category') + 1
	)[0];
	useEffect(() => {
		if ((partsCategoryFilter?.static || (!partsCategoryFilter?.static && dynamicPartsCategoryFilter)) && partsCategoryFilter?.dynamic !== dynamicPartsCategoryFilter)
			setPartsCategoryFilter({
				...partsCategoryFilter,
				dynamic: dynamicPartsCategoryFilter,
			});
	}, [dynamicPartsCategoryFilter, partsCategoryFilter]);

	// Size Range Width
	const [widthFilter, setWidthFilter] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'Size Range Width'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'Size Range Width') + 1
		)[0],
	});
	const dynamicWidthTypeFilter = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'Size Range Width'),
		props.filters?.findIndex((filter) => filter.backend_name === 'Size Range Width') + 1
	)[0];
	useEffect(() => {
		if ((widthFilter?.static || (!widthFilter?.static && dynamicWidthTypeFilter)) && widthFilter?.dynamic !== dynamicWidthTypeFilter) setWidthFilter({ ...widthFilter, dynamic: dynamicWidthTypeFilter });
	}, [dynamicWidthTypeFilter, widthFilter]);

	// Size Range Height
	const [heightFilter, setHeightFilter] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'Size Range Height'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'Size Range Height') + 1
		)[0],
	});
	const dynamicHeightTypeFilter = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'Size Range Height'),
		props.filters?.findIndex((filter) => filter.backend_name === 'Size Range Height') + 1
	)[0];
	useEffect(() => {
		if ((heightFilter?.static || (!heightFilter?.static && dynamicHeightTypeFilter)) && heightFilter?.dynamic !== dynamicHeightTypeFilter)
			setHeightFilter({
				...heightFilter,
				dynamic: dynamicHeightTypeFilter,
			});
	}, [dynamicHeightTypeFilter, heightFilter]);

	// Amount of Light
	const [lightFilter, setLightFilter] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'Amount of Light'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'Amount of Light') + 1
		)[0],
	});
	const dynamicLightTypeFilter = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'Amount of Light'),
		props.filters?.findIndex((filter) => filter.backend_name === 'Amount of Light') + 1
	)[0];
	useEffect(() => {
		if ((lightFilter?.static || (!lightFilter?.static && dynamicLightTypeFilter)) && lightFilter?.dynamic !== dynamicLightTypeFilter) setLightFilter({ ...lightFilter, dynamic: dynamicLightTypeFilter });
	}, [dynamicLightTypeFilter, lightFilter]);

	// Panel Grain
	const [panelGrainFilter, setPanelGrainFilter] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'Panel Grain'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'Panel Grain') + 1
		)[0],
	});
	const dynamicPanelGrainFilter = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'Panel Grain'),
		props.filters?.findIndex((filter) => filter.backend_name === 'Panel Grain') + 1
	)[0];
	useEffect(() => {
		if ((panelGrainFilter?.static || (!panelGrainFilter?.static && dynamicPanelGrainFilter)) && panelGrainFilter?.dynamic !== dynamicPanelGrainFilter)
			setPanelGrainFilter({
				...panelGrainFilter,
				dynamic: dynamicPanelGrainFilter,
			});
	}, [dynamicPanelGrainFilter, panelGrainFilter]);

	// Exterior Color
	const [exteriorColorFilter, setExteriorColorFilter] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'Exterior Color' || staticFilter.backend_name === 'Exterior Finish'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'Exterior Color') + 1
		)[0],
	});
	const dynamicExteriorColorFilter = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'Exterior Color'),
		props.filters?.findIndex((filter) => filter.backend_name === 'Exterior Color') + 1
	)[0];
	useEffect(() => {
		if ((exteriorColorFilter?.static || (!exteriorColorFilter?.static && dynamicExteriorColorFilter)) && exteriorColorFilter?.dynamic !== dynamicExteriorColorFilter)
			setExteriorColorFilter({
				...exteriorColorFilter,
				dynamic: dynamicExteriorColorFilter,
			});
	}, [dynamicExteriorColorFilter, exteriorColorFilter]);

	// Interior Finish
	const [interiorFinishFilter, setInteriorFinishFilter] = useState({
		static: props.staticFilters?.slice(
			props.staticFilters.findIndex((staticFilter) => staticFilter.backend_name === 'Interior Finish'),
			props.staticFilters?.findIndex((staticFilter) => staticFilter.backend_name === 'Interior Finish') + 1
		)[0],
	});
	const dynamicInteriorFinishFilter = props.filters?.slice(
		props.filters.findIndex((filter) => filter.backend_name === 'Interior Finish'),
		props.filters?.findIndex((filter) => filter.backend_name === 'Interior Finish') + 1
	)[0];
	useEffect(() => {
		if ((interiorFinishFilter?.static || (!interiorFinishFilter?.static && dynamicInteriorFinishFilter)) && interiorFinishFilter?.dynamic !== dynamicInteriorFinishFilter)
			setInteriorFinishFilter({
				...interiorFinishFilter,
				dynamic: dynamicInteriorFinishFilter,
			});
	}, [dynamicInteriorFinishFilter, interiorFinishFilter]);

	// Stock - filters needs refactored so instead of ignoring, it'll be an order-setting array
	const ignoreFilters = ['transaction-type', 'material-type', 'product-line', 'Parts Category', 'Size Range Width', 'Size Range Height', 'Amount of Light', 'Panel Grain', 'Exterior Color', 'Interior Finish', 'product-type'];
	const [apiFilters, setApiFilters] = useState([]);
	const apiFiltersArr = props.filters?.filter((filter) => !ignoreFilters.includes(filter.backend_name) && !props.staticFilters.map((item) => item.backend_name).includes(filter.backend_name));
	useEffect(() => {
		if (apiFiltersArr.length > 0) {
			let newArr = [];
			for (let i = 0; i < apiFiltersArr.length; i++) {
				// check for answers and tile count on answers
				if (apiFiltersArr[i].answers?.length > 0 && apiFiltersArr[i].answers.filter((answer) => answer.tile_count > 0)?.length > 0) {
					newArr.push({ dynamic: apiFiltersArr[i] });
				}
			}
			setApiFilters(newArr);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- preexisting failure, fix when possible
	}, [props.filters]);

	if (props.staticFilters.length > 0) {
		allOtherFilters = [/* Material Type */ !props.staticFilters?.find((staticFilter) => staticFilter.backend_name === 'material-type')?.hidden && materialTypeFilter, /* Product Line */ !props.staticFilters?.find((staticFilter) => staticFilter.backend_name === 'product-line')?.hidden && productLineFilter, /* Parts Category */ !props.staticFilters?.find((staticFilter) => staticFilter.backend_name === 'Parts Category')?.hidden && partsCategoryFilter, /* Size Range Width */ !props.staticFilters?.find((staticFilter) => staticFilter.backend_name === 'Size Range Width')?.hidden && widthFilter, /* Size Range Height */ !props.staticFilters?.find((staticFilter) => staticFilter.backend_name === 'Size Range Height')?.hidden && heightFilter, /* Amount of Light */ !props.staticFilters?.find((staticFilter) => staticFilter.backend_name === 'Amount of Light')?.hidden && lightFilter, /* Panel Grain */ !props.staticFilters?.find((staticFilter) => staticFilter.backend_name === 'Panel Grain')?.hidden && panelGrainFilter, /* Exterior Color */ !props.staticFilters?.find((staticFilter) => staticFilter.backend_name === 'Exterior Color')?.hidden && exteriorColorFilter, /* Interior Finish */ !props.staticFilters?.find((staticFilter) => staticFilter.backend_name === 'Interior Finish')?.hidden && interiorFinishFilter, /* Product Type */ !props.staticFilters?.find((staticFilter) => staticFilter.backend_name === 'product-type')?.hidden && productTypeFilter, /* API Filters */ ...apiFilters];
	}

	function updateFilterSelection(checkedState, updatedQuestion, updatedAnswer) {
		const currentQueryParams = new URLSearchParams(queryString.parse(window.location.search)).get('options');
		checkedState ? addParam(currentQueryParams, updatedQuestion, updatedAnswer) : removeParam(currentQueryParams, updatedQuestion, updatedAnswer);
	}

	function addParam(currentQueryParams, updatedQuestion, updatedAnswer) {
		const updatedQueryParams = [];
		if (currentQueryParams) {
			currentQueryParams.split('|').map((qaPair) => {
				const qaPairArray = qaPair.split('=');
				if (qaPairArray.length !== 2) return null;
				updatedQueryParams.push([qaPairArray[0] + '=' + qaPairArray[1]]);
			});
			updatedQueryParams.push([updatedQuestion + '=' + updatedAnswer?.backend_name?.replaceAll('+', '%2B')]);
		} else {
			updatedQueryParams.push([updatedQuestion + '=' + updatedAnswer?.backend_name?.replaceAll('+', '%2B')]);
		}
		history.replaceState(null, '', window.location.pathname + '?options=' + updatedQueryParams.join('|').replaceAll(',|', '|').replaceAll('+', '%2B'));
		setUpdateProductListing(true);

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'PLP-filterInfo',
			filter: {
				name: updatedAnswer.backend_name,
				value: updatedQuestion,
			},
		});
	}

	function removeParam(currentQueryParams, updatedQuestion, updatedAnswer) {
		const updatedQueryParams = [];
		if (currentQueryParams) {
			currentQueryParams.split('|').map((qaPair) => {
				const qaPairArray = qaPair.split('=');
				if (qaPairArray.length !== 2) return null;
				if (qaPairArray[0] === updatedQuestion) {
					if (qaPairArray[1].indexOf(',') > -1) {
						// Remove answer from question with comma delimited answers
						updatedQueryParams.push([updatedQuestion + '=' + qaPairArray[1].replace(updatedAnswer, '')]);
					} else if (qaPairArray[1] === updatedAnswer.backend_name) {
						// Remove question and answer if question has single answer
						return null;
					} else {
						// Add back question with still selected answer
						updatedQueryParams.push([qaPairArray[0] + '=' + qaPairArray[1]]);
					}
				} else {
					// Add back other questions
					updatedQueryParams.push([qaPairArray[0] + '=' + qaPairArray[1]]);
				}
			});
		} else {
			// add error messaging
			return null;
		}
		history.replaceState(null, '', window.location.pathname + '?options=' + updatedQueryParams.join('|').replace(',|', '|').replace('+', '%2B'));
		setUpdateProductListing(true);
	}

	const [updateProductListing, setUpdateProductListing] = props.reloadProductListing;

	// Filter - Show More/Show Less
	const filterLimit = 5;
	const [expandedFilters, setExpandedFilters] = useState([]);
	const toggleFilter = (filter) => {
		setExpandedFilters({
			...expandedFilters,
			[filter]: !expandedFilters[filter],
		});
	};

	return (
		<div className={`plpFilters top-[59px] max-xl:fixed max-xl:z-10 max-xl:h-screen max-xl:w-[330px] max-xl:max-w-[80%] max-xl:overflow-auto max-xl:bg-white max-xl:px-5 max-xl:py-6 max-xl:shadow-[0_5px_8px_rgba(0,0,0,0.5)] max-xl:duration-[250ms] md:top-[63px] ${styles.plpFilters} ${props.showOnMobile ? 'left-0' : '-left-full'}`}>
			{/* Transaction Filters/Buy It Now */}
			{Array.isArray(transactionFilters?.static?.answers) && !transactionFilters?.static?.hidden && props.pageUrl !== '/shop/windows/stock/' && props.pageUrl !== '/shop/parts/all/' && (
				<div className={styles.plpFilters_Group}>
					<h2 className={styles.filterHeading}>{CSdata.contentstackPlpConfig?.get_it_fast?.heading}</h2>
					<ul className='m-0 list-none p-0'>
						{(transactionFilters?.dynamic ?? transactionFilters?.static)?.answers.map((transactionFilter, index) => {
							if (transactionFilter?.backend_name === 'buy-now' && !transactionFilters?.static?.answers?.find((answer) => answer.backend_name === 'buy-now')?.hidden) {
								return (
									<li
										key={`${index}-${transactionFilter.backend_name}`}
										className={`${styles.plpFilters_LinkWrapper} ${transactionFilter.tile_count === 0 ? styles.plpFilters_LinkWrapper_disabled : ''}`}
									>
										<Checkbox
											key={`${transactionFilter.backend_name}-${index}`}
											id={`${transactionFilter.backend_name}-${index}`}
											labelText={`${transactionFilter.display_name} (${transactionFilter.tile_count})`}
											onChange={() => {
												updateFilterSelection(document.getElementById(`${transactionFilter.backend_name}-${index}`).checked, (transactionFilters?.dynamic ?? transactionFilters?.static)?.backend_name, transactionFilter);
											}}
											disabled={transactionFilter.tile_count === 0}
											checked={transactionFilter.selected}
											groupClass='[&>label]:text-sm ml-5'
										/>
									</li>
								);
							}
						})}
					</ul>
				</div>
			)}

			{/* Filters */}
			{isValidArray(allOtherFilters) && allOtherFilters.some((filter) => ((filter?.dynamic ?? filter?.static)?.display_name !== undefined && (filter?.dynamic ?? filter?.static)?.answers.some((answer) => answer?.tile_count > 0)) || filter?.static?.backend_name === 'product-line') && (
				<div className={styles.plpFilters_Group}>
					<h2 className={styles.filterHeading}>{CSdata.contentstackPlpConfig?.top_filters?.heading}</h2>
					{allOtherFilters.map((otherFilter, index) => {
						if (otherFilter === false || otherFilter === undefined) return null;

						if ((otherFilter?.dynamic ?? otherFilter?.static)?.answers?.length && (otherFilter?.dynamic ?? otherFilter?.static)?.answers.filter((answer) => answer.tile_count > 0).length > 0) {
							return (
								<ul
									key={`${(otherFilter?.dynamic ?? otherFilter?.static)?.backend_name}-${index}`}
									className='m-0 list-none p-0'
								>
									<li className={styles.plpFilters_ListItem}>
										<input
											type='checkbox'
											id={`checkbox-group-1-${index}`}
										/>
										<label
											htmlFor={`checkbox-group-1-${index}`}
											className={styles.plpFilters_Dropdown}
										>
											<h3 className='!text-body-2 font-semibold'>{(otherFilter?.dynamic ?? otherFilter?.static)?.display_name}</h3>
											<Icon
												name='add'
												className={styles.plpFilters_unchecked}
											/>
											<Icon
												name='remove'
												className={styles.plpFilters_checked}
											/>
										</label>
										<div id={(otherFilter?.dynamic ?? otherFilter?.static)?.backend_name}>
											{(otherFilter?.dynamic ?? otherFilter?.static)?.answers
												.filter((ans) => ans.tile_count !== 0 || (ans.tile_count === 0 && ans?.url))
												// .filter(ans => !ans.hidden)
												.filter((ans) => !otherFilter?.static?.answers?.find((staticAnswer) => staticAnswer.backend_name === ans.backend_name)?.hidden)
												.sort((lesser, greater) => greater.tile_count - lesser.tile_count)
												.map((answer, index) => {
													//temporary removal for new parts rollouts
													if ((props.pageUrl === '/shop/parts/all/' && answer.backend_name === 'Window Hardware') || (props.pageUrl === '/shop/parts/all/' && answer.backend_name === 'Door Hardware')) return null;
													if (typeof otherFilter?.static?.answers?.find((staticAnswer) => staticAnswer.backend_name === answer.backend_name)?.url === 'string') {
														// Links
														return (
															<div
																key={`${index}-${(otherFilter?.dynamic ?? otherFilter?.static)?.backend_name}`}
																className={`${styles.plpFilters_LinkWrapper} ${!expandedFilters[(otherFilter?.dynamic ?? otherFilter?.static)?.display_name] && index >= filterLimit ? styles.plpFilters_hidden : ''}`}
															>
																<Link
																	to={otherFilter?.static?.answers?.find((staticAnswer) => staticAnswer.backend_name === answer.backend_name).url}
																	key={`${(otherFilter?.dynamic ?? otherFilter?.static)?.backend_name}-${answer.backend_name}-${index}`}
																	className={styles.plpFilters_Link}
																>
																	{answer.display_name}
																	<Icon name='keyboard_arrow_right' />
																</Link>
															</div>
														);
													} else {
														// Checkboxes
														return (
															<div
																key={`${index}-${(otherFilter?.dynamic ?? otherFilter?.static)?.backend_name}`}
																className={` ${!expandedFilters[(otherFilter?.dynamic ?? otherFilter?.static)?.display_name] && index >= filterLimit ? styles.plpFilters_hidden : ''}`}
															>
																<Checkbox
																	id={`${(otherFilter?.dynamic ?? otherFilter?.static)?.backend_name}-${index}`}
																	labelText={`${answer.display_name} (${answer.tile_count})`}
																	onChange={() => {
																		updateFilterSelection(document.getElementById(`${(otherFilter?.dynamic ?? otherFilter?.static)?.backend_name}-${index}`).checked, (otherFilter?.dynamic ?? otherFilter?.static)?.backend_name, answer);
																	}}
																	checked={answer.selected}
																	groupClass='[&>label]:text-sm'
																/>
															</div>
														);
													}
												})}

											{(otherFilter?.dynamic ?? otherFilter?.static)?.answers.filter((item) => item.tile_count !== 0 || (item.tile_count === 0 && item?.url)).length > filterLimit && (
												<button
													type='button'
													onClick={() => toggleFilter((otherFilter?.dynamic ?? otherFilter?.static)?.display_name)}
													className={styles.plpFilters_ShowBtn}
												>
													<span>{expandedFilters[(otherFilter?.dynamic ?? otherFilter?.static)?.display_name] ? 'Show Less' : 'Show More'}</span>
												</button>
											)}
										</div>
									</li>
								</ul>
							);
						}
					})}
				</div>
			)}

			{/* Department Filters */}
			{Array.isArray(departmentFilters?.static?.answers) && !departmentFilters?.static?.hidden && (
				<div className={styles.plpFilters_Group}>
					<h2 className={styles.filterHeading}>{CSdata.contentstackPlpConfig?.departments?.heading}</h2>
					<ul className='m-0 list-none p-0'>
						{departmentFilters?.static?.answers.map((departmentFilter, index) => {
							if (!departmentFilter || !departmentFilter.url || (departmentFilter.hidden && !departmentFilter.selected) || (departmentFilter.display_name?.toLowerCase().includes('stock') && !props.isEastCoast)) return null;
							return (
								<li
									key={`${index}-${departmentFilter.backend_name}`}
									className={styles.plpFilters_LinkWrapper}
								>
									<Link
										to={departmentFilter.url}
										className='flex items-center justify-between text-sm no-underline hover:underline [&_span]:justify-end'
									>
										{departmentFilter.display_name}
										<Icon name='keyboard_arrow_right' />
									</Link>
								</li>
							);
						})}
					</ul>
				</div>
			)}

			{!isValidArray(props?.staticFilters) && (
				<Alert
					type='info'
					className='mb-4'
					hideClose
				>
					Sorry, there were no filters found for these results.
				</Alert>
			)}
		</div>
	);
};

export default Filter;

Filter.propTypes = {
	staticFilters: PropTypes.array,
	filters: PropTypes.array,
	pageUrl: PropTypes.string,
	productQueryParams: PropTypes.string,
	reloadProductListing: PropTypes.array,
	data: PropTypes.object,
	dynamicPageState: PropTypes.bool,
	showOnMobile: PropTypes.bool,
	isEastCoast: PropTypes.bool,
};

export const query = graphql`
	{
		contentstackPlpConfig {
			get_it_fast {
				heading
			}
			departments {
				heading
			}
			top_filters {
				heading
			}
		}
	}
`;
